/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_CookInputs */

const en_today_cook = /** @type {(inputs: Today_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cook today`)
};

const de_today_cook = /** @type {(inputs: Today_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute kochen`)
};

/**
* | output |
* | --- |
* | "Cook today" |
*
* @param {Today_CookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const today_cook = /** @type {((inputs?: Today_CookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_CookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_today_cook(inputs)
	return en_today_cook(inputs)
});